import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'localizeValuePipe',
  standalone: true
})
export class LocalizeValuePipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(value: any): string {
    if (!value || typeof value !== 'object') {
      return '-';
    }

    const currentLang = this.translate.currentLang || 'en-US';
    const localizedValue = value[currentLang];

    if (!localizedValue || localizedValue === 'null' || localizedValue === null) {
      return '-';
    }

    return localizedValue;
  }

}
